import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { getToken, getRole, removeToken } from '../../../utils/cookies/cookies'
import NotAuthrized from '../../../pages/NotAuthrized';

// Route filtering based on roles, similar to filterSidebar
const filterRoutesForRole = (role, path) => {
  switch (role) {
    case 'admin':
      return true; // Admin has access to all routes

    case 'HR':
      return (
        path === '/' || // Dashboard
        path.startsWith('/team') || // Team-related routes
        path.startsWith('/task') || // Task
        path.startsWith('/company') || // Company
        path.startsWith('/document') || // Document
        path.startsWith('/leave') || // Document
        path.startsWith('/attendance') || // Document
        path.startsWith('/salary') || // Document
        path.startsWith('/360view') || // Document
        path.startsWith('/arview') || // Document
        path.startsWith('/overdue-task') ||
        path === '/profile' ||// Profile
        path === '/notification' ||
        path === '/social-list'
      );

      case 'Team Leader' : 
      return (
        path === '/' ||
        path.startsWith('/task') ||
        path.startsWith('/overdue-task') ||
        path === '/profile' ||
        path === '/notification'
      )

    case 'Social Media Coordinator':
      return (
        path === '/' || // Dashboard
        path.startsWith('/task') || // Task
        path.startsWith('/company-branding') || // Company Branding
        path === '/profile' ||// Profile
        path === '/notification'
      );

    default:
      return (
        path === '/' || // Dashboard
        path.startsWith('/task') || // Task
        path === '/profile' || // Profile
        path === '/notification'
      );
  }
};

// PrivateRoute component for role-based access control
export default function PrivateRoute() {
  const token = getToken(); // Get token to check if the user is authenticated
  const role = getRole(); // Get user role from cookies or wherever it's stored
  const location = useLocation(); // Get the current route path

  if (!token) {
    // If not logged in, redirect to login page
    return <Navigate to='/login' />;
  }

  // Check if the user has permission to access the current route
  const hasAccess = filterRoutesForRole(role, location.pathname);

  if (!hasAccess) {
    // If the user doesn't have access, show Not Authorized page or redirect elsewhere
    return <NotAuthrized />
  }

  // If the user has access, render the requested component
  return <Outlet />;
}

